import { topicsItems } from '@/mocks/home';

export default function TopicsSection() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
  };

  return (
    <section id="topics" className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 tracking-wide">
            热门话题
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            大家都在讨论的影视话题，加入热议圈子
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicsItems.map((topic) => (
            <a
              key={topic.label}
              href="#topics"
              onClick={handleClick}
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full cursor-pointer no-underline transition-all duration-200 ${
                topic.hot
                  ? 'bg-accent-100/70 text-accent-800 border border-accent-300/50 hover:bg-accent-200/70'
                  : 'bg-background-100/70 text-foreground-700 border border-background-200/70 hover:border-foreground-300/50'
              }`}
            >
              {topic.hot && (
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-fire-line text-xs text-primary-500"></i>
                </span>
              )}
              <span className="text-sm font-medium">{topic.label}</span>
              <span className="text-xs opacity-60 ml-1">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}